import { EditDialogService } from '../../../core/components/editDialog/editDialogService';
import { CommandInput, CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { CommandService, Flow, HasCommands } from '../../../core/services/command/command.service';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { AddressDialogComponent } from "src/app/shared-module/components/address-dialog/address-dialog.component";
import { Address } from "src/app/shared-module/shared/entities/address/address";


export abstract class AbstractTaskUpdateAddressCommandCustomFlow implements Flow {

  public dialogRef: DynamicDialogRef | undefined;

  constructor(
    private dialogService: EditDialogService
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      let addressId = commandTemplate?.flow?.settings?.customFlowSettings?.addressId;
      let address = new Address();
      address.id = addressId;

      this.dialogRef = this.dialogService.open(AddressDialogComponent, {
        width: "1100px",
        header: 'Adresse bearbeiten',
        data: {
          address: address,
        }
      });
      this.dialogRef.onClose.subscribe((result) => {
        // result is true or false, indiciating if it should refetch
        if(result){
          commandInput.addParameter("addressInput", result.addressInput);
          commandService.sendCommand(commandInput, () => {
            completionCallback();
          })
        }
      });

  }
  
}